export const ReportTypeEnum = {
  COMPLETO: 'completo',
  SIMPLIFICADO: 'simplificado',
};

export const ReportTypeLabel = {
  [ReportTypeEnum.COMPLETO]: 'Completo',
  [ReportTypeEnum.SIMPLIFICADO]: 'Simplificado',
};
